import { useBrowseLayoutQuery } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/v3/useBrowseLayoutQuery";
import { useIsBrowseTopLayoutLoadedAndHasNoResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/v3/useIsBrowseTopLayoutLoadedAndHasNoResults";
import { useCategoryPageActionName } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useCategoryPageActionName";
import { useCurrentNavigationPath } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";
import { markPageJsExecuted } from "@faire/web--source/common/performance/TrackPerformanceBreakdown/markPageJsExecuted";
import { UPLTHookOptions } from "@faire/web--source/common/performance/userPerceivedLoadTiming/useUserPerceivedLoadTiming";
import { ViewLayoutPlacement } from "@faire/web-api--source/indigofair/data/ViewLayoutPlacement";

const useIgnoreImages = () => {
  const isBrowseTopLayoutLoadedAndHasNoResults =
    useIsBrowseTopLayoutLoadedAndHasNoResults();
  const isBrowseTopLayoutError = useBrowseLayoutQuery(
    ViewLayoutPlacement.TOP
  ).isError;

  return isBrowseTopLayoutLoadedAndHasNoResults || isBrowseTopLayoutError;
};

const pageJsExecutedMark = markPageJsExecuted();

export const useSDUIHubPageUPLT = (): Omit<
  UPLTHookOptions,
  "numComponents"
> => {
  const {
    isError: isBrowseTopLayoutError,
    isFetching: isFetchingBrowseTopLayout,
    data: topViewLayout,
    dataUpdatedAt: browseTopLayoutUpdatedAt,
  } = useBrowseLayoutQuery(ViewLayoutPlacement.TOP);

  const isBrowseTopLayoutLoading =
    isFetchingBrowseTopLayout || topViewLayout === undefined;

  const pageName = useCategoryPageActionName();
  const ignoreImages = useIgnoreImages();
  const navigationPath = useCurrentNavigationPath();

  return {
    name: pageName,
    isPageLoading: isBrowseTopLayoutLoading && !isBrowseTopLayoutError,
    ignoreImages,
    enableTrackPerformanceBreakdown: "internal-tracking",
    pageLoadKey: JSON.stringify(["HUB-PAGE-QUERY", navigationPath]),
    dataUpdatedAt: browseTopLayoutUpdatedAt,
    pageJsExecutedMark: pageJsExecutedMark,
  };
};
